export default {"src":"/_next/static/media/white-chevron-right.a25a78d2.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};